import { useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BidQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const DELETE_BID_WIN_THEME_MUTATION = graphql(`
  mutation deleteBidWinTheme($id: String!) {
    deleteBidWinTheme(id: $id) {
      id
    }
  }
`);

export function useDeleteBidWinTheme({ bidId }: { bidId: string }) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(DELETE_BID_WIN_THEME_MUTATION, {
    onSuccess: (data) => {
      const deletedId = data.deleteBidWinTheme.id;
      queryClient.setQueryData<BidQuery>(["bid", bidId], (prevData) => {
        if (!prevData?.bid) return prevData;
        return {
          ...prevData,
          bid: {
            ...prevData.bid,
            winThemes: prevData.bid.winThemes.filter((theme) => theme.id !== deletedId),
          },
        };
      });
    },
  });

  return { data: data?.deleteBidWinTheme, ...rest };
}
